<template>
  <div
    class="search-loader-parts"
    :class="{'search-loader-parts--loading': loading}"
  >
    <span></span>
  </div>
</template>

<script>
import {defineComponent, computed} from 'vue'

export default defineComponent({
  name: 'SearchLoaderParts',
  props: {
    enabledLoader: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const loading = computed(() => props.enabledLoader)
    return {
      loading
    }
  },
})

</script>